export default IconRotateDot => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-rotate-dot" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5" />
  <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
</svg>`;